import { Action } from '@/constants/constants';
import { Feature } from '@/constants/features';
import { Module } from '@/constants/modules';

export const roleSettingsRoutes = [
	{
		path: `/${Module.SETTINGS.name}/${Feature.ROLES}`,
		name: `/${Module.SETTINGS.name}/${Feature.ROLES}`,
		component: () => import('./components/RoleSettingsPage'),
	},
	{
		path: `/${Module.SETTINGS.name}/${Feature.ROLES}/${Action.MODIFY}`,
		name: `/${Module.SETTINGS.name}/${Feature.ROLES}/${Action.MODIFY}`,
		component: () => import('./components/RoleModifyPage'),
	},
	{
		path: `/${Module.SETTINGS.name}/${Feature.ROLES}/${Action.MODIFY}/:roleId`,
		name: `/${Module.SETTINGS.name}/${Feature.ROLES}/${Action.MODIFY}/:roleId`,
		component: () => import('./components/RoleModifyPage'),
		props: true,
	},
];
